module.exports = __webpack_public_path__ + "src/assets/textures/env/hoe/hoe_512_Bake.png";